import { render, staticRenderFns } from "./SlotPreferenceModal.vue?vue&type=template&id=10cf53c0"
import script from "./SlotPreferenceModal.vue?vue&type=script&lang=js"
export * from "./SlotPreferenceModal.vue?vue&type=script&lang=js"
import style0 from "./SlotPreferenceModal.vue?vue&type=style&index=0&id=10cf53c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports